import { IntegrationsSenderItemList } from "@/pages/integrations/shared/integrations-list";
import { MDSIcon, MDSIconColor, MDSIconKind, MDSSection, MDSSectionSlotName, MDSLink } from "@/mds";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC, useEffect } from "react";
import { useAppStore } from "@/store";
import { windowModule } from "@/modules/window";
import { IntegrationsLoader } from "@/pages/integrations/shared/integrations-loader";
import {
  StyledContentList,
  StyledContentSectionTitleWrapper,
  StyledContentStatusWrapper,
  StyledContentWrapper,
} from "@/pages/integrations/shared/integrations.styles";
import { IntegrationsLayoutBottomBuffer } from "@/pages/integrations/shared/integrations-layout";

export const IntegrationsTextMessagePageContent: FC = observer(() => {
  const { store } = useAppStore();
  const { verifiedItems, isLoading, loadSettings } = store.textMessageSenders;
  const isConnected = verifiedItems.length > 0;

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  return (
    <StyledContentWrapper>
      <MDSSection
        title={
          <StyledContentSectionTitleWrapper>
            <MDSIcon kind={MDSIconKind.Message} />
            SMS & WhatsApp Integration
          </StyledContentSectionTitleWrapper>
        }
      >
        <div slot={MDSSectionSlotName.HeaderRightAddon}>
          {isConnected && (
            <StyledContentStatusWrapper>
              Connected
              <MDSIcon kind={MDSIconKind.CheckCircleSolid} color={MDSIconColor.Positive} />
            </StyledContentStatusWrapper>
          )}
        </div>
        <StyledContentList>
          <li>
            Text Mem at{" "}
            <StyledPhoneLink
              onPress={() => windowModule.navigateToExternal({ url: new URL("sms:+12192477722") })}
            >
              +1-219-247-7722
            </StyledPhoneLink>{" "}
            from your verified SMS and/or WhatsApp phone numbers
          </li>
          <li>
            Send Mem your quick thoughts and ideas, which will be automatically transformed into
            structured, organized notes - or added to existing notes!
          </li>
          <li>The original text thread will be attached to the new note(s) for your reference</li>
        </StyledContentList>
      </MDSSection>

      {isLoading ? <IntegrationsLoader /> : <IntegrationsSenderItemList itemKind="text-message" />}
      <IntegrationsLayoutBottomBuffer />
    </StyledContentWrapper>
  );
});

const StyledPhoneLink = styled(MDSLink)`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;
